export default [{
  district: "-------------纽约--------------",
  users: [{
    name: 'April Huang'
  }, {
    name: 'Binyao Wang'
  }, {
    name: 'Eric Chang'
  }, {
    name: 'Jean Liu'
  }, {
    name: 'Lillian Gu'
  }, {
    name: 'Kat Zhou'
  }, {
    name: 'Nathan Zheng'
  }, {
    name: 'Vicky Sun'
  }]
}, {
  district: "------------洛杉矶------------",
  users: [{
    name: 'Vivi Ren'
  }, {
    name: 'Kai Xia'
  }, {
    name: 'Katherine Chen'
  }, {
    name: 'Leah Zhao'
  }, {
    name: 'Maggie Zhang'
  }, {
    name: 'Meidong Li'
  }, {
    name: 'Panpan Qin'
  }, {
    name: 'Nina Li'
  }]
}, {
  district: "-------------波士顿--------------",
  users: [{
    name: 'Jay Liu'
  }, {
    name: 'Adam Veaner'
  }, {
    name: 'Alba Xia'
  }, {
    name: 'Mingyi Li'
  }]
}, {
  district: "-------------旧金山湾区--------------",
  users: [{
    name: 'Hannah Gong'
  }, {
    name: 'Cici Deng'
  }]
}, {
  district: "-------------西雅图--------------",
  users: [{
    name: 'Echo Zhao'
  }]
}, {
  district: "-------------达拉斯--------------",
  users: [{
    name: 'Adam Xia'
  }, {
    name: 'Kevin Ji'
  }]
}, {
  district: "-------------温哥华--------------",
  users: [{
    name: 'Kylie Lu'
  }]
}, {
  district: "-------------多伦多--------------",
  users: [{
    name: 'WeiWei'
  }, {
    name: 'Min Ma'
  }]
}, {
  district: "-------------拉斯维加斯--------------",
  users: [{
    name: 'Ann An'
  }, {
    name: 'Kevin Ji'
  }]
}, {
  district: "-------------圣地亚哥--------------",
  users: [{
    name: 'Yi Zheng'
  }]
}, {
  district: "-------------休斯顿--------------",
  users: [{
    name: 'Ran Tai'
  }]
}, {
  district: "-------------其他--------------",
  users: [{
    name: 'others'
  }]
}]



// WEBPACK FOOTER //
// ./src/config/businessUser.js